import styled from "styled-components";
import { Slider } from "antd";
import { SliderSingleProps } from "antd/lib";
import { COLORS } from "styles/colors";
import { useCallback, useMemo } from "react";

type Props = {} & SliderSingleProps;

const StorageSlider = (props: Props): JSX.Element => {
  const step = 1;
  const isSingleValue =
    props.min !== undefined &&
    props.max !== undefined &&
    props.min === props.max;

  const marks = useMemo(() => {
    if (props.min === undefined || props.max === undefined) return {};
    const obj: Record<number, React.ReactNode> = {};
    for (let i = props.min; i <= props.max; i += step) {
      obj[i] = i;
    }
    return obj;
  }, [props.min, props.max]);

  const onClickSingleValue = useCallback(() => {
    if (!isSingleValue || props.min === undefined) return;
    props.onChange?.(props.min);
    props.onAfterChange?.(props.min);
  }, [isSingleValue, props.min, props.onChange, props.onAfterChange]);

  return (
    <Container className="storage-slider-wrapper" onClick={onClickSingleValue}>
      <Slider {...props} step={step} marks={marks} />
    </Container>
  );
};

const Container = styled.div`
  .ant-slider-mark-text {
    color: ${({ theme }) => theme.COLORS.WHITE};
  }
  .ant-slider-rail {
    background-color: ${({ theme }) =>
      theme.value === "light" ? theme.COLORS.BORDER : COLORS.BORDER};
  }

  /* .ant-slider {
    :hover {
      .ant-slider-track {
        background-color: ${({ theme }) =>
    theme.value === "light"
      ? theme.COLORS.BUTTONS1
      : theme.COLORS.WIDGETCOLOR}10;
      }
    }
  }

 
  .ant-slider-track {
    background-color: ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.BUTTONS1 : theme.COLORS.WIDGETCOLOR};
  }

  .ant-slider-handle {
    :focus {
      ::after {
        box-shadow: 0 0 0 2.5px
          ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.BUTTONS1 : theme.COLORS.WIDGETCOLOR};
      }
    }
    ::after {
      box-shadow: 0 0 0 2px
        ${({ theme }) =>
    theme.value === "light" ? theme.COLORS.BUTTONS1 : theme.COLORS.WIDGETCOLOR};
    }
  } */
`;

export default StorageSlider;
